module.exports = "/_next/static/images/0dcde1d81157563fd347023a5b357b52-girl-holding-card@xs.jpg.webp";